export class SlideshowOverlay {
  containerWidth = '';
  containerPadding = 'uk-section';
  margin = 'uk-padding';
  position = 'uk-flex-top';
  style = 'uk-overlay-default';
  width = '';
  transition = 'uk-transition-fade';
  padding = '';
  parallaxValues: number[] = [];

  static normalize(styles: Partial<SlideshowOverlay>): SlideshowOverlay {
    const pureStyles = new SlideshowOverlay();

    pureStyles.containerWidth = styles.containerWidth ?? pureStyles.containerWidth;
    pureStyles.containerPadding = styles.containerPadding ?? pureStyles.containerPadding;
    pureStyles.margin = styles.margin ?? pureStyles.margin;
    pureStyles.position = styles.position ?? pureStyles.position;
    pureStyles.style = styles.style ?? pureStyles.style;
    pureStyles.width = styles.width ?? pureStyles.width;
    pureStyles.transition = styles.transition ?? pureStyles.transition;
    pureStyles.padding = styles.padding ?? pureStyles.padding;
    pureStyles.parallaxValues = styles.parallaxValues ?? pureStyles.parallaxValues;

    return pureStyles;
  }
}
